module.exports = __webpack_public_path__ + "img/baie-mont-saint-michel-big.f085040d.jpg";